import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import Segmented from './segmented.vue'

const checkedStyle = ['white', 'blue']

// props
export const segmentedProps = buildProps({
  // 选中风格
  checkedStyle: {
    type: String,
    values: checkedStyle,
    default: 'blue',
  },
  // 开启悬浮效果
  useHover: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type SegmentedProps = ExtractPropTypes<typeof segmentedProps>

// 导出segmented实列类型
export type SegmentedInstance = InstanceType<typeof Segmented>
